import i18n from "@/shared/config/i18n";

const KK_KZ = ["kk", "kz"];

function currentLocale(fallback) {
  if (fallback) return String(fallback).toLowerCase();
  const loc = i18n?.global?.locale;
  const value =
    loc && typeof loc === "object" && "value" in loc ? loc.value : loc;
  return String(value || "ru").toLowerCase();
}

export function getLocalizedMessage(detail, fallbackLocale) {
  if (!detail) return null;
  if (typeof detail === "string") return detail;

  const locale = currentLocale(fallbackLocale);

  const candidates = [
    detail[locale],
    KK_KZ.includes(locale) ? detail.kk || detail.kz : null,
    detail.ru,
    detail.en,
    detail.message,
  ].filter(Boolean);

  return candidates[0] || null;
}

export function getErrorCode(detail) {
  if (!detail || typeof detail === "string") return null;
  return detail.status || detail.code || null;
}
